"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CareersContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
require("react-phone-input-2/lib/style.css");
require("./style.scss");
var ApplicationDetails_1 = require("./FormGroups/ApplicationDetails");
var PersonalInformation_1 = __importDefault(require("./FormGroups/PersonalInformation"));
var ContactInformation_1 = __importDefault(require("./FormGroups/ContactInformation"));
var Section_1 = __importDefault(require("./FormGroups/Section"));
var utils_1 = require("./utils");
var swr_1 = __importDefault(require("swr"));
var __1 = require("..");
var constants_1 = require("./constants");
exports.CareersContext = (0, react_1.createContext)(null);
var Careers = function (props) {
    var formMethods = (0, react_hook_form_1.useForm)({ reValidateMode: "onChange" });
    var handleSubmit = formMethods.handleSubmit, control = formMethods.control;
    var _a = (0, react_1.useState)(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = (0, swr_1.default)("formOptions", function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, __1.client
                            .get(props.urls.GET_FORM_OPTIONS)
                            .then(function (res) { return res.data; })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
                case 2:
                    error_1 = _a.sent();
                    (0, utils_1.handleError)(error_1);
                    setTimeout(function () {
                        props.back();
                    }, 300);
                    return [2 /*return*/, {}];
                case 3: return [2 /*return*/];
            }
        });
    }); }, {
        compare: function (a, b) { return JSON.stringify(a) === JSON.stringify(b); },
        errorRetryCount: 3,
        errorRetryInterval: 500,
    }), formOptions = _b.data, isLoading = _b.isLoading;
    var formToken = (0, swr_1.default)("formToken", function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, __1.client
                            .get(props.urls.GET_TOKEN)
                            .then(function (res) { return res.data; })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.application_token];
                case 2:
                    error_2 = _a.sent();
                    (0, utils_1.handleError)(error_2);
                    return [2 /*return*/, {}];
                case 3: return [2 /*return*/];
            }
        });
    }); }).data;
    function uploadFile(file, type) {
        return __awaiter(this, void 0, void 0, function () {
            var fileTOBase64, uploadFile, _a, _b, _c;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        fileTOBase64 = function (file) {
                            return new Promise(function (resolve, reject) {
                                var reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = function () {
                                    var result = reader.result;
                                    resolve(result.split(",")[1]);
                                };
                                reader.onerror = function (error) { return reject(error); };
                            });
                        };
                        _b = (_a = __1.client).post;
                        _c = [props.urls.UPLOAD_FILE + type];
                        _d = {
                            name: file[0].name
                        };
                        return [4 /*yield*/, fileTOBase64(file[0])];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([(_d.data = _e.sent(),
                                _d), {
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Careers-Application-Token": formToken || "",
                                },
                            }]))];
                    case 2:
                        uploadFile = _e.sent();
                        return [2 /*return*/, uploadFile.data.id];
                }
            });
        });
    }
    function onSubmit(data) {
        return __awaiter(this, void 0, void 0, function () {
            var submitData, _a, _b, error_3, res, error_4;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 9, , 10]);
                        setIsSubmitting(true);
                        submitData = data;
                        submitData.department || props.query.get("department") || "";
                        submitData.job =
                            props.query.get("jobId") || submitData.job || "";
                        submitData.type = "create_application";
                        submitData.dob = submitData.dob
                            ? new Date(submitData.dob).getTime()
                            : undefined;
                        submitData.experiences = (0, utils_1.getDate)(submitData.experiences);
                        submitData.academic = (0, utils_1.getDate)(submitData.academic);
                        submitData.courses = (0, utils_1.getDate)(submitData.courses);
                        submitData.experiences = (0, utils_1.getDate)(submitData.experiences);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, , 7]);
                        if (!(submitData.photo && (submitData === null || submitData === void 0 ? void 0 : submitData.photo.length) > 0)) return [3 /*break*/, 3];
                        _a = submitData;
                        return [4 /*yield*/, uploadFile(submitData.photo, "photo")];
                    case 2:
                        _a.photo = _c.sent();
                        _c.label = 3;
                    case 3:
                        if (!(submitData.cv_file && submitData.cv_file.length > 0)) return [3 /*break*/, 5];
                        _b = submitData;
                        return [4 /*yield*/, uploadFile(submitData.cv_file, "cv_file")];
                    case 4:
                        _b.cv_file = _c.sent();
                        _c.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_3 = _c.sent();
                        (0, utils_1.handleError)(error_3);
                        setIsSubmitting(false);
                        return [2 /*return*/];
                    case 7: return [4 /*yield*/, __1.client.post(props.urls.CREATE_APPLICATION, submitData, {
                            headers: {
                                "X-Careers-Application-Token": formToken || "",
                            },
                        })];
                    case 8:
                        res = _c.sent();
                        setIsSubmitting(false);
                        if (res.status === 200) {
                            (0, utils_1.successMessage)((0, utils_1.t)("applicationSubmitted"));
                            setTimeout(function () {
                                props.push("/");
                            }, 300);
                        }
                        return [3 /*break*/, 10];
                    case 9:
                        error_4 = _c.sent();
                        (0, utils_1.handleError)(error_4);
                        setIsSubmitting(false);
                        console.warn(error_4);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }
    var enabledSections = Object.values((formOptions === null || formOptions === void 0 ? void 0 : formOptions.enabled_sections) || {}).filter(function (section) {
        return typeof section === "string" &&
            !!(formOptions === null || formOptions === void 0 ? void 0 : formOptions[section]);
    });
    // Consecutive detail/upload fields are grouped so they share one row.
    var formGroups = [];
    ((formOptions === null || formOptions === void 0 ? void 0 : formOptions.form_order) || constants_1.DEFAULT_FORM_ORDER).forEach(function (name) {
        var kind = ApplicationDetails_1.DETAIL_FIELDS.includes(name)
            ? "field"
            : ApplicationDetails_1.UPLOAD_FIELDS.includes(name)
                ? "upload"
                : "block";
        var last = formGroups[formGroups.length - 1];
        if (kind !== "block" && (last === null || last === void 0 ? void 0 : last.kind) === kind) {
            last.names.push(name);
        }
        else {
            formGroups.push({ kind: kind, names: [name] });
        }
    });
    var firstDetailsGroup = formGroups.findIndex(function (group) { return group.kind !== "block"; });
    var renderSection = function (section) { return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: section, rules: {
            required: (0, utils_1.isSectionRequired)(section, formOptions === null || formOptions === void 0 ? void 0 : formOptions.required_sections),
        }, render: function (_a) {
            var field = _a.field;
            return ((0, jsx_runtime_1.jsx)(Section_1.default, __assign({}, field, { section: formOptions === null || formOptions === void 0 ? void 0 : formOptions[section], title: section, requiredFields: formOptions === null || formOptions === void 0 ? void 0 : formOptions.required, isRequired: (0, utils_1.isSectionRequired)(section, formOptions === null || formOptions === void 0 ? void 0 : formOptions.required_sections) })));
        } })); };
    return ((0, jsx_runtime_1.jsx)("div", { className: "!container", children: (0, jsx_runtime_1.jsx)(exports.CareersContext.Provider, { value: { options: formOptions, title: props.tittle }, children: (0, jsx_runtime_1.jsx)(react_hook_form_1.FormProvider, __assign({}, formMethods, { children: (0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit(onSubmit), className: "grid gap-spacing", children: [(0, jsx_runtime_1.jsx)(ApplicationDetails_1.JobDetails, { showTitle: props.showTitle, showJobSelect: props.showJobSelect, urls: props.urls, query: props.query }), formGroups.map(function (group, index) { return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [index === firstDetailsGroup && (0, jsx_runtime_1.jsx)(ApplicationDetails_1.ApplicationDetailsTitle, {}), group.kind === "field" && (0, jsx_runtime_1.jsx)(ApplicationDetails_1.DetailFields, { names: group.names }), group.kind === "upload" && ((0, jsx_runtime_1.jsx)(ApplicationDetails_1.UploadFields, { names: group.names })), group.kind === "block" &&
                                    group.names[0] === "personal_information" && ((0, jsx_runtime_1.jsx)(PersonalInformation_1.default, {})), group.kind === "block" &&
                                    group.names[0] === "contact_information" && ((0, jsx_runtime_1.jsx)(ContactInformation_1.default, {})), group.kind === "block" &&
                                    enabledSections.includes(group.names[0]) && ((0, jsx_runtime_1.jsx)("div", { className: "flex max-w-[inherit] flex-col gap-spacing overflow-auto", children: renderSection(group.names[0]) }))] }, group.names.join())); }), (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "p-fi-lg w-full bg-fi-secondary hover:bg-fi-secondary-hover border-0 rounded-fi text-fi-secondary-font", children: (0, utils_1.t)("Submit") })] }) })) }) }));
};
exports.default = Careers;
